import { jsxs as m, jsx as i } from "react/jsx-runtime";
import { useMultiStyleConfig as _, chakra as o } from "@chakra-ui/react";
const v = ({
  __css: s,
  __cssContent: n,
  children: a,
  isLoading: r = !1,
  size: c,
  variant: d,
  ...e
}) => {
  const t = _("SmartAnimation", {
    size: c,
    variant: d
  });
  return /* @__PURE__ */ m(o.div, { __css: { ...t.root, ...s }, ...e, "data-root": "", children: [
    /* @__PURE__ */ i(o.div, { __css: t.animation, children: /* @__PURE__ */ i(
      o.div,
      {
        __css: { ...t.content, ...n },
        "data-loading": r ? "" : void 0
      }
    ) }),
    a
  ] });
};
export {
  v as SmartAnimation
};
//# sourceMappingURL=SmartAnimation.es.js.map
